import { Box, Text, Stack } from '@stitch-fix/mode-react';
import { ReactNode } from 'react';
import { CurrentGalleryEmpty } from './CurrentGalleryEmpty';
import { HighValueReferralsPromoCard } from './HighValueReferralsPromoCard';
import { SupportedBusinessLine } from '../../onboarding/Onboarding';
import { GalleryQuickAction, type GalleryQuickActionData } from '../GalleryQuickAction';
export const CurrentGalleryHeader = ({
  showEmptyState = false,
  topContent,
  isPromoTreatment = false,
  businessLine = 'WOMENS',
  galleryQuickActionModule
}: {
  showEmptyState?: boolean | null;
  topContent?: ReactNode;
  isPromoTreatment?: boolean;
  businessLine?: SupportedBusinessLine;
  galleryQuickActionModule?: GalleryQuickActionData | null;
}) => {
  return <Stack spacing={1}>
      <Text align={{
      sm: 'left',
      md: 'center'
    }} setting="display-medium" color="blue-45" mb={0.5} mt={1}>
        Your <strong>Vision gallery</strong>
      </Text>
      {galleryQuickActionModule ? <GalleryQuickAction module={galleryQuickActionModule} /> : null}
      {showEmptyState && <CurrentGalleryEmpty businessLine={businessLine} />}
      {topContent ? <Box>{topContent}</Box> : null}
      {isPromoTreatment ? <HighValueReferralsPromoCard /> : null}
    </Stack>;
};